import React from "react";
import { Slide } from "react-reveal";
import p1 from "../../assets/images/content1/6.png";
import p2 from "../../assets/images/content1/5.png";
import p3 from "../../assets/images/content1/9.png";
import RecentProjectCardCompleted from "../reusables/RecentProjectCardCompletetd";

const ProjectsBody = () => {
  return (
    <section className="section-spacing-80 triangles-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-content">
              <div className="section-content">
                <div className="section-body section-spacing-20 width-800 margin-auto">
                  <div class="card-container">
                    <RecentProjectCardCompleted
                      projectname="Dan G+5 Modern Apartment"
                      projectcompletion="08/2025"
                      projectsize="G+5 Apartment, Fence and Landcape Work"
                      projectowner="DAN General Trading Co. Ltd"
                      projectlocation="Tompin Area"
                      projectvalue="450,000 (Labor Cost Only)"
                      projectstart=" 02/2024"
                      img={p1}
                    />
                    <RecentProjectCardCompleted
                      projectname="Ware house and Fence Project"
                      projectcompletion="01/2025"
                      projectsize="150m by 60m"
                      projectowner="Star Distillers Co.Ltd"
                      projectlocation="Gumbo - Rajaf"
                      projectvalue="375,000 ( Labor Cost Only)"
                      projectstart=" 05/2023"
                      img={p2}
                    />
                    <RecentProjectCardCompleted
                      projectname="Plakton General Trading Warehouse and Fence"
                      projectcompletion="07/2024"
                      projectsize="50m by 20m Warehouse"
                      projectowner="Plankton General Trading"
                      projectlocation="Gumbo"
                      projectvalue="120,000 (Labor cost Only)"
                      projectstart=" 02/2023"
                      img={p3}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsBody;
